import getConfig from "./config";

const config = getConfig();

/**
 *
 * @return {String|null}
 */
const getResponsiveType = () => {
    let matchedType = null;

    for (let [bp, width] of Object.entries(config.responsiveBps).reverse()) {
        if (window.innerWidth >= width) {
            for (let [type, bps] of Object.entries(config.responsiveTypes)) {
                if (bps.includes(bp)) {
                    matchedType = type;
                    break;
                }
            }

            break;
        }
    }

    return matchedType;
};
const isResponsiveBreakpoint = (breakpoint) =>
    (config.responsiveBps[breakpoint] ?? 9999) <= window.innerWidth;
const isTouchDevice = () => {
    let maxTouchPoints = 0;
    try {
        maxTouchPoints = (window.top || window).navigator.maxTouchPoints;
        Number.isFinite(maxTouchPoints) && (maxTouchPoints &= 255);
    } catch (err) {
        console.error(err);
    }

    return (
        0 < maxTouchPoints ||
        ("ontouchstart" in window && window.ontouchstart !== null)
    );
};

export {getResponsiveType, isResponsiveBreakpoint, isTouchDevice};
